import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { buildProductArgs } from 'Utils/graphql';
import { LINE_PRODUCT_PRICE_TICKET_CUSTOM } from 'Utils/request/requestDictionary';
type CMSProps = {
  resortId: string;
  getAQuoteCTA: string;
  getAQuoteURL: string;
};
type GQLProps = {
  resort: Product;
  config: {
    common: {};
  };
};
export type LineProps = CMSProps & GQLProps;
export const resolve: Resolve<GQLProps, CMSProps, ProductRouterLocation> = async (
  appContext,
  { resortId: productId },
  _pageContext,
  { urlParams },
) => {
  const productArgs = buildProductArgs(productId, urlParams);
  const query = `query {
    config {
      common {
        close
      }
    }
    resort(${productArgs}) {
      badgeIcon
      color
      comfortLabel
      destination {
        country
      }
      hasECSpace
      isExplicitEC
      mice {
        bestPrice {
          value
          formattedValue
        }
        unit
      }
      name
      type
    }
  }`;
  return graphQLClient.runQuery(query, appContext, {
    requestName: LINE_PRODUCT_PRICE_TICKET_CUSTOM,
  });
};
